import styled from 'styled-components'
import { themeGet } from 'styled-system'

import { fadeInAnimation } from 'styles/animation'
import theme from 'styles/theme'
import { getBGColor } from 'utils/themeUtils'

export const Overlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  padding: ${theme.space[4]};
  width: 100vw;
  height: 100vh;
  background: hsla(0, 0%, 100%, 0.5);
  opacity: ${(props) => (props.isClosing ? 0 : 1)};
  animation: ${fadeInAnimation} 0.2s ease-in-out;
  transition: opacity 0.2s ease-in-out;
  z-index: 100;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${theme.space[4]} ${theme.space[4]} ${theme.space[10]};
  width: calc(100vw - 40px);
  max-width: ${theme.maxWidths[0]};
  height: auto;
  max-height: calc(100vh - 40px);
  background: ${getBGColor()};
  border: 1px solid ${themeGet('colors.alto')};
`

export const ContentWrapper = styled.div`
  height: 100%;
  overflow-x: auto;
`

export const CloseButton = styled.button`
  float: right;
  margin: 0 0 ${theme.space[2]};
  padding: 0;
  border: 0;
  background: none;

  > span {
    height: 20px;
  }
`
